export const ORDER_LOADING = 'ORDER_LOADING';
export const ORDER_ERROR = 'ORDER_ERROR';
export const ORDER_SUCCESS = 'ORDER_SUCCESS';
export const ORDER_RESET = 'ORDER_RESET';
export const START_POLLING_ORDERS = 'START_POLLING_ORDERS';
export const STOP_POLLING_ORDERS = 'STOP_POLLING_ORDERS';
